import React from 'react';

export type ResetPasswordData = {
  notification?: string;
};

export const DEFAULT_RESET_PASSWORD_DATA: ResetPasswordData = {};

type ResetPasswordDataContextValue = {
  resetPasswordData: ResetPasswordData;
  setResetPasswordData: React.Dispatch<React.SetStateAction<ResetPasswordData>>;
};

export const ResetPasswordDataContext = React.createContext<ResetPasswordDataContextValue>({
  resetPasswordData: DEFAULT_RESET_PASSWORD_DATA,
  setResetPasswordData: () => null,
});
